/** Strom modulů v UI — stejná pravidla jako src/modules/module-tree.ts (parent=acm je kořen). */

export function nestModules<T extends { name: string; parent?: string | null }>(
  modules: T[],
): Array<T & { children: T[] }> {
  const byName = new Map(modules.map((m) => [m.name, m]));
  const children = new Map<string, T[]>();
  const roots: T[] = [];
  for (const m of modules) {
    const p = (m.parent ?? '').trim();
    if (!p || p === 'acm' || !byName.has(p) || p === m.name) {
      roots.push(m);
      continue;
    }
    const list = children.get(p) ?? [];
    list.push(m);
    children.set(p, list);
  }
  return roots.map((m) => ({
    ...m,
    children: (children.get(m.name) ?? []).slice().sort((a, b) => a.name.localeCompare(b.name)),
  }));
}
